export default __webpack_public_path__ + "static/media/logo-white.0be28504.svg";